// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PreviewWrapper__PreviewContainer___1AbcA{display:flex;flex:1 1 auto;height:100%;min-width:0}.PreviewWrapper__PreviewContainerPersonalCommentingEmbedded___2WEal{display:flex;flex:1 1 auto;height:calc(100% - 49px);min-width:0;position:relative;top:49px}", ""]);
// Exports
exports.locals = {
	"PreviewContainer": "PreviewWrapper__PreviewContainer___1AbcA",
	"PreviewContainerPersonalCommentingEmbedded": "PreviewWrapper__PreviewContainerPersonalCommentingEmbedded___2WEal"
};
module.exports = exports;
